import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { faqs } from "../mock";

export default function Faq() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="py-16 lg:py-20 bg-white">
      <div className="max-w-3xl mx-auto px-4">
        <div className="text-center mb-10">
          <p className="inline-block text-teal-600 font-bold uppercase tracking-widest text-xs bg-teal-50 px-4 py-1.5 rounded-full mb-4">FAQ</p>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900">Frequently Asked Questions</h2>
        </div>
        <div className="space-y-3">
          {faqs.map((f, i) => (
            <div key={i} className="border border-slate-200 rounded-xl overflow-hidden">
              <button onClick={() => setOpen(open === i ? -1 : i)} className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left">
                <span className="font-semibold text-slate-800">{f.q}</span>
                <span className="w-7 h-7 rounded-full bg-teal-50 text-teal-600 flex items-center justify-center shrink-0">
                  {open === i ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                </span>
              </button>
              <div className={`px-5 overflow-hidden transition-all duration-300 ${open === i ? "max-h-48 pb-4" : "max-h-0"}`}>
                <p className="text-sm text-slate-500 leading-relaxed">{f.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
